export default "__VITE_ASSET__fcUQY34D__"